import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";

export default class FMPSelect extends Component {
	render () {
		const { label, path, controller, options, helpText, md, disabled, contained } = this.props;

		const { state } = controller;
		const { formFieldError } = state;

		const onChange = (this.props.onChange)
			? this.props.onChange
			: event => controller.onChange(event, path);

		if (!_.isFunction(onChange)) {
			console.error('onChange not a function. Controller missing onChange?');
			return;
		}

		if (!_.isObject(formFieldError)) {
			console.error('Controller missing formFieldError object');
			return;
		}


		//let value, onChange, error;
		const value = _.get(state, path, '') || '';
		const error = _.get(formFieldError, path);
		const hasError = !!error;
		const randomId = `selection${_.random(9999999)}`;

		const content = (
			<Grid item xs={12} md={md} style={{margin:'5px 0px'}}>
				<FormControl fullWidth={true} error={hasError} disabled={disabled}>
					<InputLabel htmlFor={randomId}>{label}</InputLabel>
					<Select
						value={value}
						onChange={onChange}
						input={<Input name={randomId} id={randomId}/>}
					>
						{options.map(option => {
							return (<MenuItem key={option.value} value={option.value}>
								{option.display}
							</MenuItem>);
						})}
					</Select>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{(helpText && !hasError) && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		);

		if (contained) {
			return (
				<Grid spacing={2} container>
					{content}
				</Grid>
			);
		} else {
			return content;
		}
	}
}

FMPSelect.propTypes = {
	label : PropTypes.string.isRequired,
	path: PropTypes.array.isRequired,
	controller: PropTypes.object.isRequired,
	options : PropTypes.array.isRequired,

	onChange : PropTypes.func,
	helpText : PropTypes.string,
	contained : PropTypes.bool,
	disabled : PropTypes.bool,
	md : PropTypes.number,
};

FMPSelect.defaultProps = {
	contained : true,
	md : 12,
};